<template>
  <div>
    <div>
      <div class="player-area">
        <video ref="vid2" id="vid1" class="video-js" width=480 height=270 controls>
        </video>
<!--        <div ref="control" class="control-panel" @click.prevent="toggleMute">-->
<!--          <button class="mute-btn">음소거</button>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import videojs from 'video.js'
import { getStreaming } from '@/common/utils/request'
import { getGUID } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
export default {
  name: 'PlayerTest',
  data () {
    return {
      player: null
    }
  },
  methods: {
    play () {
      this.player.play()
    },
    stop () {
      this.player.pause()
    }
    // toggleMute () {
    //   this.player.muted(!this.player.muted())
    // }
  },
  created () {
    const linkEl = document.createElement('link')
    linkEl.setAttribute('href', 'https://vjs.zencdn.net/7.10.2/video-js.css')
    linkEl.setAttribute('rel', 'stylesheet')
    document.head.appendChild(linkEl)
  },
  mounted () {
    getStreaming({
      contenttype: 'vod',
      contentid: 'K01_PS-2020189224-01-000.1',
      action: 'hls',
      quality: '1080p',
      lastplayid: 'none',
      isabr: 'y',
      ishevc: 'n',
      authtype: 'cookie',
      guid: getGUID()
    }).then(({ data }) => {
      const [key, value] = data.awscookie.split('=')
      cookie.setItem(key, value, null, '.wavve.com', '/', false)
      this.player = videojs(this.$refs.vid2, {
        html5: {
          hls: {
            overrideNative: true
          }
      }
      })
      this.player.ready(function () {
        this.src({
          src: data.playurl,
          type: 'application/x-mpegURL',
          withCredentials: true
        })
      })
    })
  },
  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>
<style lang="css">
  /*.player-area {*/
  /*  position: relative;*/
  /*  width: 480px;*/
  /*  height: 270px;*/
  /*}*/
  /*.control-panel {*/
  /*  position: absolute;*/
  /*  width: 50px;*/
  /*  height: 50px;*/
  /*  background-color: red;*/
  /*  bottom: 10px;*/
  /*  right: 10px;*/
  /*}*/
  /*.mute-btn {*/
  /*  background-color: green;*/
  /*}*/
</style>
